// ONIT Water Filtration opt-in checkbox component

interface OnitWaterSectionProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function OnitWaterSection({ checked, onChange, disabled }: OnitWaterSectionProps) {
  return (
    <div className="onit-water-section">
      <div className={`option-card${checked ? ' option-card--selected' : ''}`}>
        <div className="option-card__header">
          <div className="option-card__checkbox-wrapper">
            <input
              type="checkbox"
              id="onit-water-filtration"
              className="option-card__checkbox"
              checked={checked}
              onChange={(e) => onChange(e.target.checked)}
              disabled={disabled}
            />
          </div>
          <div className="option-card__content">
            <div className="option-card__title-row">
              <label htmlFor="onit-water-filtration" className="option-card__name">
                I would like a complimentary home water test provided by ONIT Water Filtration
              </label>
              <span className="option-card__badge option-card__badge--free">Free</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
